module.exports = __webpack_public_path__ + "static/media/button-eye-request.f1af365d.svg";